import * as React from "react";
import { useAthlete } from "./store";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { getAgeTypeRegular, getCompetitionClassTypeAbbreviation, getCompetitorTypeRegular, getDisciplineTypeRegular, getSeriesTypeRegular } from "public_app/view/entity";
import { AgeType, DisciplineType, SeriesType } from "public_app/events/entity";
import { cls_colorCyan60, cls_colorCyan70, cls_colorGrey90, cls_gap_2p5rem, cls_gap_form, cls_h5, cls_p5r, cls_wrap } from "style/index.css";
import { cls_box_info_param, cls_box_ranking_points, cls_box_ranking_points_content, cls_box_width_param, cls_box_width_param_big, cls_box_width_value } from "./view_competitor_data.css";
import { cls_align_items_flex_end, cls_align_items_flex_start, cls_align_items_stretch } from "framework/structural_components/hbox_vbox.css";
import { getDateComparison, getDateText_DayMonthNameYear } from "framework/helpers";
import { useUIContext } from "common/uicontext/store";
var View = function (props) {
    var _a, _b, _c, _d, _e;
    var _f = useAthlete(), _g = _f[0], loadingTooLong = _g.loadingTooLong, loading = _g.loading, loadFailure = _g.loadFailure, entity = _g.entity, actions = _f[1];
    var _h = useUIContext(), uicontext_state = _h[0], uicontext_actions = _h[1];
    var idt = props.idt;
    React.useEffect(function () {
        actions.loadAthlete(idt);
        uicontext_actions.loadMemberUIContext(idt);
    }, [idt]);
    var athleteIsMember = (_a = uicontext_state.data.member) === null || _a === void 0 ? void 0 : _a.isMember;
    var unknownMembershipStatus = ((_b = uicontext_state.data.member) === null || _b === void 0 ? void 0 : _b.isMember) === null || ((_c = uicontext_state.data.member) === null || _c === void 0 ? void 0 : _c.isMember) === undefined;
    var userCompetitors = (_d = uicontext_state.data.logged_user) === null || _d === void 0 ? void 0 : _d.relatedPersons;
    var showMembershipStatus = !unknownMembershipStatus && ((_e = uicontext_state.data.member) === null || _e === void 0 ? void 0 : _e.id) === idt && userCompetitors !== null && userCompetitors !== undefined ? userCompetitors.filter(function (uc) { return uc.idt === idt; }).length > 0 : false;
    var showContent = entity != null && !loading && !loadFailure && entity.idt === idt;
    // const presenceOfNonAdultRankingAge = entity.rankingPoints.filter(rp => getAgeTypeFromString(rp.rankingAge) !== AgeType.Adult).length > 0;
    // const commonMedCheckValid = entity.medicalCheckupExpiration != undefined;
    var anyRPMedCheckValid = entity.rankingPoints.filter(function (rp) { return rp.medicalCheckupExpiration != undefined; }).length >= 0;
    var anyRPMedCheckDifferentFromCommonMedCheck = entity.rankingPoints.filter(function (rp) { return !getDateComparison(rp.medicalCheckupExpiration, entity.medicalCheckupExpiration); }).length >= 0;
    var onlyOneMedicalCheckupExpirationValue = anyRPMedCheckDifferentFromCommonMedCheck && anyRPMedCheckValid;
    var columnWidthClassnameRP = onlyOneMedicalCheckupExpirationValue ? cls_box_width_param : cls_box_width_param_big;
    var columnWidthClassnameCommon = onlyOneMedicalCheckupExpirationValue ? cls_box_info_param : cls_box_width_param_big;
    var anySeniorCategoryPresent = entity.rankingPoints.map(function (rp) {
        return [
            AgeType.Senior,
            AgeType.Senior_I,
            AgeType.Senior_II,
            AgeType.Senior_III,
            AgeType.Senior_IV,
            AgeType.Senior_V
        ].includes(rp.rankingAge);
    }).includes(true);
    var athleteAge = entity.age;
    return React.createElement(React.Fragment, null, showContent ? React.createElement(VBox, { className: [cls_gap_form, cls_box_ranking_points_content, cls_p5r, cls_align_items_flex_start] },
        React.createElement(HBox, { className: [cls_gap_2p5rem, cls_align_items_flex_end, cls_h5] },
            React.createElement(VBox, null, entity.name),
            React.createElement(VBox, { className: cls_colorCyan70 }, entity.idt)),
        React.createElement(VBox, { className: [cls_gap_form, cls_align_items_stretch] },
            React.createElement(VBox, { className: [cls_gap_form, cls_box_ranking_points] },
                React.createElement(HBox, { className: cls_p5r }, "Spole\u010Dn\u00E9 \u00FAdaje"),
                React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(HBox, { className: [columnWidthClassnameCommon, cls_colorCyan60] }, "\u00DAdaje platn\u00E9 ke dni"),
                    React.createElement(HBox, null, getDateText_DayMonthNameYear(entity.validFor))),
                showMembershipStatus && React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(HBox, { className: [columnWidthClassnameCommon, cls_colorCyan60] }, "\u010Clenstv\u00ED v \u010CSTS"),
                    React.createElement(HBox, null, athleteIsMember ? "aktivní" : "neaktivní")),
                onlyOneMedicalCheckupExpirationValue && React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(HBox, { className: [columnWidthClassnameCommon, cls_colorCyan60] }, "Platnost zdravotn\u00ED prohl\u00EDdky"),
                    React.createElement(HBox, null, entity.medicalCheckupExpiration ? getDateText_DayMonthNameYear(entity.medicalCheckupExpiration) : 'není evidována žádná platná zdravotní prohlídka')),
                athleteAge !== AgeType.Unknown && React.createElement(HBox, { className: cls_gap_form },
                    React.createElement(HBox, { className: [columnWidthClassnameCommon, cls_colorCyan60] }, "V\u011Bk sout\u011B\u017E\u00EDc\u00EDho"),
                    React.createElement(HBox, null, getAgeTypeRegular(athleteAge)))),
            entity.rankingPoints.map(function (rp, idx) {
                var competitor = rp.competitors;
                var discipline = rp.discipline;
                var rankingAge = rp.rankingAge;
                var competitorAge = rp.age;
                var series = rp.series;
                var competitorIsSenior = [
                    AgeType.Senior,
                    AgeType.Senior_I,
                    AgeType.Senior_II,
                    AgeType.Senior_III,
                    AgeType.Senior_IV,
                    AgeType.Senior_V
                ].includes(competitorAge);
                var ageToDisplay = anySeniorCategoryPresent || competitorIsSenior
                    ? rankingAge
                    : rankingAge === AgeType.Adult && competitorAge !== AgeType.Under_21
                        ? competitorAge
                        : rankingAge;
                var rpNamingArray = [];
                if (series !== SeriesType.Unknown) {
                    rpNamingArray.push('Seriál ' + getSeriesTypeRegular(series));
                }
                if (discipline !== DisciplineType.Unknown) {
                    rpNamingArray.push('disciplína ' + getDisciplineTypeRegular(discipline));
                }
                if (competitor !== null) {
                    rpNamingArray.push(getCompetitorTypeRegular(competitor));
                }
                if (ageToDisplay !== AgeType.Unknown) {
                    rpNamingArray.push(getAgeTypeRegular(ageToDisplay));
                }
                var rpNaming = rpNamingArray.join(', ');
                return React.createElement(VBox, { className: [cls_gap_form, cls_box_ranking_points], key: idx },
                    React.createElement(HBox, { className: cls_p5r }, rpNaming),
                    rp.partner != null && React.createElement(HBox, { className: cls_gap_form },
                        React.createElement(HBox, { className: [columnWidthClassnameRP, cls_colorCyan60] }, "Partner(ka)"),
                        React.createElement(HBox, { className: cls_box_width_value },
                            rp.partner,
                            " (",
                            rp.partnerIdt,
                            ")")),
                    rp.points !== null && rp.points !== undefined && React.createElement(HBox, { className: cls_gap_form },
                        React.createElement(HBox, { className: [columnWidthClassnameRP, cls_colorCyan60] }, "Sout\u011B\u017En\u00ED za\u0159azen\u00ED"),
                        React.createElement(HBox, { className: [cls_gap_form, cls_wrap] },
                            React.createElement(HBox, { className: cls_box_width_value },
                                "t\u0159\u00EDda: ",
                                getCompetitionClassTypeAbbreviation(rp.class),
                                ", body: ",
                                rp.points,
                                ", fin\u00E1le tuz./zahr.: ",
                                rp.domesticFinaleCount,
                                "/",
                                rp.foreignFinaleCount),
                            rp.approved === false && React.createElement(HBox, { className: cls_colorGrey90 }, "p\u0159edb\u011B\u017En\u00E9"))),
                    rp.personalPoints !== null && rp.personalPoints !== undefined && React.createElement(HBox, { className: cls_gap_form },
                        React.createElement(HBox, { className: [columnWidthClassnameRP, cls_colorCyan60] }, "Osobn\u00ED za\u0159azen\u00ED"),
                        React.createElement(HBox, { className: [cls_gap_form, cls_wrap] },
                            React.createElement(HBox, { className: cls_box_width_value },
                                "t\u0159\u00EDda: ",
                                getCompetitionClassTypeAbbreviation(rp.personalClass),
                                ", body: ",
                                rp.personalPoints,
                                ", fin\u00E1le tuz./zahr.: ",
                                rp.personalDomesticFinaleCount,
                                "/",
                                rp.personalForeignFinaleCount),
                            rp.personalApproved === false && React.createElement(HBox, { className: cls_colorGrey90 }, "neaktu\u00E1ln\u00ED, \u010Dek\u00E1 na uz\u00E1v\u011Brku sout\u011B\u017En\u00EDch bod\u016F"))),
                    !onlyOneMedicalCheckupExpirationValue && React.createElement(HBox, { className: cls_gap_form },
                        React.createElement(HBox, { className: [columnWidthClassnameRP, cls_colorCyan60] }, "Platnost zdravotn\u00ED prohl\u00EDdky"),
                        React.createElement(HBox, null, rp.medicalCheckupExpiration ? getDateText_DayMonthNameYear(rp.medicalCheckupExpiration) : 'není evidována žádná platná zdravotní prohlídka')));
            }))) : null);
};
export { View as CompetitorDataView, };
